<template>
  <div>
    <h2>Relatório de cliente</h2>
    <v-container fluid>
      <v-card class="mb-2">
        <v-card-title>
          #{{ code }} - {{ clientResponse.client.full_name }} - {{ clientResponse.blockchain_id }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                :value="clientResponse.client.social_reason ? clientResponse.client.social_reason : clientResponse.client.full_name"
                label="Nome"
                readonly
              ></v-text-field>
            </v-col>

            <v-col>
              <v-text-field
              :value="clientResponse.client.cpf ? clientResponse.client.cpf : clientResponse.client.cnpj"
                label="CPF/CNPJ"
                readonly
              ></v-text-field>
            </v-col>

            <v-col>
              <v-text-field
              :value="clientResponse.client.passport"
                label="Passaporte"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                :value="clientResponse.client.birthday"
                label="Data de nascimento"
                readonly
              ></v-text-field>
            </v-col>

            <v-col>
              <v-text-field
              :value="clientResponse.created_at"
                label="Abertura da conta"
                readonly
              ></v-text-field>
            </v-col>

            <v-col>
              <v-text-field
              :value="clientResponse.email"
                label="E-mail"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                :value="clientResponse.is_active ? 'Sim' : 'Não'"
                label="Ativo (Liberado para uso)"
                readonly
              ></v-text-field>
            </v-col>

            <v-col>
              <v-text-field
              :value="clientResponse.password_locked_at ? 'Sim' : 'Não'"
                label="Senha bloqueada"
                readonly
              ></v-text-field>
            </v-col>

            <v-col :v-if="clientResponse.client.cnpj">
              <v-text-field
              :value="clientResponse.client.cpf_legal_responsible"
                label="CPF Responsável Legal"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>


      <v-card class="mb-2">
        <v-card-title>
          Saldos do Cliente
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col lg="4">
              <v-text-field
              v-model="dataSaldo"
              label="Filtrar por data"
              type="date"
              ></v-text-field>
            </v-col>
            <v-col lg="4">
              <v-btn
                elevation="2"
                @click="loadBalances(dataSaldo)"
              >Filtrar</v-btn>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headersBalance"
            :items="balanceData"
            :items-per-page="10"
            class="elevation-1"
          ></v-data-table>
        </v-card-text>
      </v-card>
      
      <v-card class="mb-2">
        <v-card-title>
          Transações Realizadas
        </v-card-title>
        <v-card-text>
            <v-row>
              <v-col lg="4">
                <v-text-field
                v-model="startDateTransactions"
                label="A partir de"
                type="date"
                ></v-text-field>
              </v-col>
              <v-col lg="4">
                <v-text-field
                v-model="endDateTransactions"
                label="Até"
                type="date"
                ></v-text-field>
              </v-col>
              <v-col lg="4">
                <v-btn
                  elevation="2"
                  @click="loadTransactions()"
                >Filtrar</v-btn>
              </v-col>
            </v-row>
            <v-data-table
              :headers="headersTransactions"
              :items="transactionsResponse"
              :items-per-page="10"
              class="elevation-1"
            ></v-data-table>
        </v-card-text>
      </v-card>
      
      <v-card class="mb-2">
        <v-card-title>
          Certificados Emitidos
        </v-card-title>
        <v-card-text>
            <v-data-table
              :headers="headersCertificate"
              :items="certificatesResponse"
              :items-per-page="10"
              class="elevation-1"
            ></v-data-table>
        </v-card-text>
      </v-card>
      
      <v-card class="mb-2">
        <v-card-title>
          Paper Wallet Emitidas
        </v-card-title>
        <v-card-text>
            <v-data-table
              :headers="headersPaperWallet"
              :items="paperWalletEmmitedResponse"
              :items-per-page="10"
              class="elevation-1"
            ></v-data-table>
        </v-card-text>
      </v-card>
      
      <v-card class="mb-2">
        <v-card-title>
          Paper Wallet Resgatadas
        </v-card-title>
        <v-card-text>
            <v-data-table
              :headers="headersPaperWallet"
              :items="paperWalletReceivedResponse"
              :items-per-page="10"
              class="elevation-1"
            ></v-data-table>
        </v-card-text>
      </v-card>

      <v-row>
        <v-col>

        </v-col>
      </v-row>

    </v-container>

    <div>
      <v-overlay
          :value="isLoading"
      >
        <v-progress-circular
            :indeterminate="isLoading"
            size="90"
        >
          Loading...
        </v-progress-circular>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import Api from "../../services/api.service";

export default {
  name: "clientReport",
  props: {
    code: {
      type: String|Number,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    data: [],
    params: {},
    
    balanceResponse: [],
    balanceData: [],

    transactionsResponse: [],

    certificatesResponse: [],
    
    paperWalletEmmitedResponse: [],

    paperWalletReceivedResponse: [],
    
    clientResponse: {
      blockchain_id: '',
      id: null,
      is_active: false,
      client: {
        full_name: null,
        cpf: '',
        cnpj: null,
        passaport: '',
        cpf_legal_responsible: '',
        birthday: '',
        social_reason: ''
      },
      email: '',
      password_locked_at: '',
      created_at: '',
    },
    
    dataSaldo: '',

    blockedBalanceResponse: null,

    //headers
    headersTransactions: [
      { text: 'Data', value: 'data_transacao' },
      { text: 'Hora', value: 'hora_transacao' },
      { text: 'Ativo', value: 'name_token' },
      { text: 'Quantidade', value: 'qtde_transacionada' },
      { text: 'Status', value: 'status' },
      { text: 'Tipo', value: 'type' },
      { text: 'Usuário', value: 'usuario' },
      { text: 'Taxas', value: 'taxas' },
      { text: 'Transferido', value: 'valor_transacionada' },
    ],

    headersBalance: [
      { text: 'Ativo', value: 'ativo' },
      { text: 'Saldo', value: 'saldo' },
      { text: 'Saldo Bloqueado', value: 'bloqueado' }
    ],


    headersCertificate: [
      { text: 'Cód. Blockchain', value: 'uuid' },
      { text: 'Ativo', value: 'active' },
      { text: 'Quantidade', value: 'tokensCount' },
      { text: 'Emitido/Compensado (Co2)', value: 'totalamountco2' }
    ],

    headersPaperWallet: [
      { text: 'Uuid', value: 'uuid' },
      { text: 'Código', value: 'code' },
      { text: 'Ativo', value: 'activeppw.name_token' },
      { text: 'Quantidade', value: 'amount' },
    ],
    startDateTransactions: '',
    endDateTransactions: ''
  }),

  watch: {
  },
  mounted() {
    this.loadBalances();
    this.loadTransactions();
    this.loadDetails();
    this.loadCertificates();
    this.loadPaperWalletEmmited();
    this.loadPaperWalletReceived();
  },

  methods: {
    ...mapMutations(["showSnackbar"]),

    loadBalances(data = null) {
      let dataAppend = '';
      if(data) {
        dataAppend = '?max_date='+data;
      }
      this.isLoading = true;
      Api.get(`/clients/admin/balance/${this.code}${dataAppend}`).then((response) => {
        this.balanceResponse = response.data;
        let newData = [
          {ativo: 'GPX/BRL', saldo: response.data.gpx, bloqueado: 0}
        ];
        response.data.actives.map((el) => {
          newData.push(
          {ativo: el.name_token, saldo: el.balance, bloqueado: 0}
          );
        });
        this.balanceData = newData;
      }).finally(() => setTimeout(() => (this.isLoading = false), 300));
    },

    loadTransactions() {
      this.isLoading = true;
      let appendFilter = '?filter=1';
      if(this.startDateTransactions.length === 10) {
        appendFilter += '&start_date='+this.startDateTransactions;
      }
      if(this.endDateTransactions.length === 10) {
        appendFilter += '&end_date='+this.endDateTransactions;
      }
      Api.get(`/clients/admin/transactions/${this.code}${appendFilter}`).then((response) => {
        this.transactionsResponse = response.data;
      }).finally(() => setTimeout(() => (this.isLoading = false), 300));
    },

    loadDetails() {
      this.isLoading = true;
      Api.get(`/clients/admin/details/${this.code}`).then((response) => {
        this.clientResponse = response.data;
        if(this.clientResponse.client.birthday) {
          let data = new Date(this.clientResponse.client.birthday); 
          this.clientResponse.client.birthday = ('0'+data.getDate()).slice(-2)+'/'+('0'+(data.getMonth()+1)).slice(-2)+'/'+data.getFullYear();
          data = new Date(this.clientResponse.created_at);
          this.clientResponse.created_at = ('0'+data.getDate()).slice(-2)+'/'+('0'+(data.getMonth()+1)).slice(-2)+'/'+data.getFullYear();
        }
      }).finally(() => setTimeout(() => (this.isLoading = false), 300));
    },

    loadCertificates() {
      this.isLoading = true;
      Api.get(`/clients/admin/certificates/${this.code}`).then((response) => {
        this.certificatesResponse = response.data;
      }).finally(() => setTimeout(() => (this.isLoading = false), 300));
    },

    loadPaperWalletEmmited() {
      this.isLoading = true;
      Api.get(`/clients/admin/paper-wallet-emmited/${this.code}`).then((response) => {
        this.paperWalletEmmitedResponse = response.data;
      }).finally(() => setTimeout(() => (this.isLoading = false), 300));
    },

    loadPaperWalletReceived() {
      this.isLoading = true;
      Api.get(`/clients/admin/paper-wallet-received/${this.code}`).then((response) => {
        this.paperWalletReceivedResponse = response.data;
      }).finally(() => setTimeout(() => (this.isLoading = false), 300));
    },
    
  }
}
</script>

<style scoped>

</style>